import type { SetupState } from "@dentacore/shared-types";

import { api } from "./client";

/**
 * What this clinic still needs before it can take a booking.
 *
 * **Clinic-scoped, not branch-scoped** — an empty clinic has no branch to put
 * in the header, which is the whole situation this call exists for.
 *
 * **Admin only** (S3). Everyone else is refused by the server, and `/setup` is
 * behind `RequireAdmin` so nobody else reaches the call in the first place.
 */
export function readSetupState(signal?: AbortSignal): Promise<SetupState> {
  return api<SetupState>("/setup-state", { signal });
}
